import * as ko from 'knockout';
import $ from 'jquery';
export default class MasterViewModel {

    public mobileMenuOpen: KnockoutObservable<boolean> = ko.observable(false as boolean);
    public cookieConsent: KnockoutObservable<boolean> = ko.observable(true as boolean);

    public checkForCookie = (name) => {

        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) {
                this.cookieConsent(true);
                return true;
            };
        }
        this.cookieConsent(false);
        return false;

    }

    public createCookie = () => {
        var date = new Date();
        date.setTime(date.getTime() + (100000000000));
        var expires = "; expires=" + date;
        document.cookie = "CookieConsent" + "=" + "true" + expires + "; path=/";
        this.cookieConsent(true);
    }

    public dismissCookie = () => {
        this.cookieConsent(true);
    }

    constructor() {
        setTimeout(() => {

            this.checkForCookie("CookieConsent");

        }, 1000);
    }
}

ko.applyBindings(new MasterViewModel()); // This makes Knockout get to work


